"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var NearbyCommuteEstimatorState_1 = require("@/pages/detail/states/NearbyCommuteEstimatorState");
var react_redux_1 = require("react-redux");
var NearbyAction_1 = require("@/pages/detail/actions/NearbyAction");
var NearbyCommuteMethods_1 = require("@/pages/detail/states/NearbyCommuteMethods");
var mapStateToProps = function (state, ownProps) { return (__assign(__assign({}, state.detail.nearbyEstimator), { t: state.detail.t, type: ownProps.type ? ownProps.type : '' })); };
var mapDispatchToProps = function (dispatch) { return ({
    onKeywordFocus: function () { return dispatch(NearbyAction_1.default.onKeywordFocus()); },
    onKeywordBlur: function () { return dispatch(NearbyAction_1.default.onKeywordBlur()); },
    onKeywordChange: function (keyword) {
        return dispatch(NearbyAction_1.default.onKeywordChange(keyword));
    },
    onItemClick: function (suggestion, i) {
        return dispatch(NearbyAction_1.default.onItemClick(suggestion, i));
    },
    setIsSelecting: function (status) {
        return dispatch(NearbyAction_1.default.setIsSelecting(status));
    },
    setCommuteMethod: function (method) {
        return dispatch(NearbyAction_1.default.setCommuteMethod(method));
    },
    onSavePlaceClick: function () { return dispatch(NearbyAction_1.default.onSavePlaceClick()); },
}); };
var nearbyCommuteEstimator = function (props) {
    var onKeywordFocus = function () { return props.onKeywordFocus(); };
    var onKeywordBlur = function () { return props.onKeywordBlur(); };
    var onKeywordChange = function (e) {
        return props.onKeywordChange(e.currentTarget.value);
    };
    var onSavePlaceClick = function () { return props.onSavePlaceClick(); };
    var renderTimeingAction = function (props) {
        return props.selectedPlace ? (React.createElement("div", { className: "c-propmap__timingaction" },
            React.createElement("button", { onClick: onSavePlaceClick, className: "o-btn o-btn--primary" },
                React.createElement("span", { className: "fas fa-save" }),
                "\u00A0",
                props.t.saveThisPlace))) : null;
    };
    var renderMethods = function (props) {
        var getCommuteMethodClass = function (method) {
            return classnames_1.default([
                'c-propmap__method',
                {
                    'c-propmap__method--active': props.commuteMethod === method,
                },
            ]);
        };
        var setCommute = function (method) {
            return props.setCommuteMethod(method);
        };
        return props.selectedPlace ? (React.createElement("div", { className: "c-propmap__actions" },
            React.createElement("div", { className: "c-propmap__methods " },
                React.createElement("a", { onClick: function () { return setCommute(NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE); }, className: getCommuteMethodClass(NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE) },
                    React.createElement("span", { className: "fas fa-car" })),
                React.createElement("a", { onClick: function () { return setCommute(NearbyCommuteMethods_1.NearbyCommuteMethods.BUS); }, className: getCommuteMethodClass(NearbyCommuteMethods_1.NearbyCommuteMethods.BUS) },
                    React.createElement("span", { className: "fas fa-bus" })),
                React.createElement("a", { onClick: function () { return setCommute(NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING); }, className: getCommuteMethodClass(NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING) },
                    React.createElement("span", { className: "fas fa-walking" }))))) : null;
    };
    var renderSuggestion = function (suggestion, i) {
        var onItemClick = function () { return props.onItemClick(suggestion, i); };
        var renderDistrict = function (suggestion) {
            return suggestion.district ? (React.createElement("div", { className: "c-forms__suggestion-district" }, suggestion.district)) : null;
        };
        return (React.createElement("div", { key: i, onClick: onItemClick, className: "c-forms__suggestion" },
            React.createElement("div", { className: "c-forms__suggestion-icon" },
                React.createElement("span", { className: "fas fa-map-marker-alt" })),
            React.createElement("div", { className: "c-forms__suggestion-body" },
                React.createElement("div", { className: "c-forms__suggestion-address" }, suggestion.address),
                renderDistrict(suggestion))));
    };
    var renderSuggestionBody = function (props) {
        if (props.suggestions === null) {
            return (React.createElement("div", { className: "c-forms__suggestion-caption" }, props.t.addPlaceKeyword));
        }
        if (props.suggestions.length === 0) {
            return (React.createElement("div", { className: "c-forms__suggestion-caption" }, props.t.addPlaceKeyword));
        }
        return props.suggestions.map(renderSuggestion);
    };
    var renderSuggestions = function (props) {
        var onSelectingStart = function () { return props.setIsSelecting(true); };
        var onSelectingEnd = function () { return props.setIsSelecting(false); };
        return props.isSuggesting ? (React.createElement("div", { onMouseEnter: onSelectingStart, onMouseLeave: onSelectingEnd, className: "c-forms__suggestions" }, renderSuggestionBody(props))) : null;
    };
    var renderCommuteIcon = function (method) {
        if (method === NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE) {
            return React.createElement("span", { className: "fas fa-car" });
        }
        if (method === NearbyCommuteMethods_1.NearbyCommuteMethods.BUS) {
            return React.createElement("span", { className: "fas fa-bus" });
        }
        if (method === NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING) {
            return React.createElement("span", { className: "fas fa-walking" });
        }
    };
    var timingClass = classnames_1.default([
        'c-propmap__timing',
        {
            'c-propmap__timing--sm': props.type === 'sm',
        },
    ]);
    return (React.createElement("div", { className: timingClass },
        React.createElement("div", { className: "c-propmap__timinggroup" },
            React.createElement("div", { className: "c-propmap__main" },
                React.createElement("div", { className: "c-propmap__routes-inner" },
                    React.createElement("div", { className: "c-forms" },
                        React.createElement("div", { className: "c-forms__row", style: { marginBottom: 0 } },
                            React.createElement("div", { className: "c-forms__title" }, props.t.getTravelTime),
                            React.createElement("div", { className: "c-forms__cols" },
                                React.createElement("div", { className: "c-forms__col" },
                                    React.createElement("div", { className: "c-forms__fields" },
                                        React.createElement("div", { className: "c-forms__field c-forms__field--addon" }, renderCommuteIcon(props.commuteMethod)),
                                        React.createElement("div", { className: "c-forms__field" },
                                            React.createElement("input", { className: "c-forms__input js-togglemethod", type: "text", placeholder: props.t.enterLocation, onFocus: onKeywordFocus, onBlur: onKeywordBlur, onChange: onKeywordChange, value: props.keyword }),
                                            renderSuggestions(props)),
                                        React.createElement("div", { className: "c-forms__field c-forms__field--addon" },
                                            React.createElement("span", { className: "fas fa-search" }))))))),
                    renderMethods(props))),
            React.createElement("div", { className: "c-propmap__side" },
                React.createElement("div", { className: "c-propmap__estimate-box" },
                    React.createElement("span", { className: "c-propmap__minute" }, props.durationValue ? props.durationValue + " " : '-- '),
                    React.createElement("span", { className: "c-propmap__unit" }, props.durationUnit === NearbyCommuteEstimatorState_1.NearbyCommuteDurationUnit.MIN
                        ? props.t.min
                        : props.t.hour)),
                React.createElement("div", { className: "c-propmap__action-box" },
                    React.createElement("button", { onClick: onSavePlaceClick, className: "o-btn o-btn--primary" }, props.t.saveThisPlace)))),
        renderTimeingAction(props)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(nearbyCommuteEstimator);
